module.exports = "<section class=\"image\" [class.fluid]=\"fluid\"><div class=\"image\"><img [src]=\"imgSource\"/></div></section>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/image/image.component.html
// module id = ../../../../../src/app/image/image.component.html
// module chunks = main